import React, { useState, useEffect } from "react";
import MasterTable from "../../../components/common/MasterTable";
import CustomAlert from "../../../helpers/CustomAlert";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import Loader from "../../../components/Loader/Loader";
import { format, isValid, parse } from "date-fns";
import HeaderWithBreadcrumb from "../../../components/common/HeaderWithBreadcrumb";
import DeliveryBoyModal from "../DeliveryBoyModal";
import AcceptOtpModal from "../../../components/CourierBag/AcceptOtpModal";
import SingleOtpModal from "../NotificationMaster/SingleOtpModal";
import AddItemBagModal from "../../../components/booking/AddItemBagModal";
import AddressDetailModal from "./AddressDetailModal";

const defaultFilterData = {
  companyId: "",
  retailerCode: "",
  pincode: "",
  fromDate: "",
  toDate: "",
  status: [],
};

const orderHeader = [
  "Products",
  "Status",
  "LMBP Id",
  "LMBP Name",
  "Consignee Name",
  "Mobile No",
  "Phone No",
  "Email Id",
  "Address Line 1",
  "Address Line 2",
  "Address Type",
  "Pincode",
  "City",
  "State",
  "Country",
  "Invoice Number",
  "Payment Mode",
  "Express Type",
  "Order Amount (₹)",
  "COD Amount (₹)",
  "Shipment Weight",
  "Shipment Length",
  "Shipment Width",
  "Shipment Height",
  "Pick Address ID",
  "Return Address ID",
  "Seller ID",
  "E-Way Bill Number",
  "Route Code",
  "Carrier",
  "Created Date",
  "Response",
  "Waybill",
];

const NotificationMasterHub = () => {
  const [pageSize, setPageSize] = useState(10);
  const [noData, setNoData] = useState(false);
  const [editData, setEditData] = useState({});
  const [data, setData] = useState([]);
  const [otpData, setOtpData] = useState(null);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [hubLoading, setHubLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const loggedInUserName = sessionStorage.getItem("username");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [columnData, setColumnData] = useState("");
  const [deliveryModalOpen, setDeliveryModalOpen] = useState(false);
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState(null);
  const [doubleOtpModalOpen, setDoubleOtpModalOpen] = useState(false);
  const [doubleOtpData, setDoubleOtpData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [acceptHub, setAcceptHub] = useState(false);
  const [isAddItemModalOpen, setIsAddItemModalOpen] = useState(false);
  const [autoSelectAll, setAutoSelectAll] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [pageDetailsModal, setPageDetailsModal] = useState(null);
  const [orderData, setOrderData] = useState([]);
  const [isAddressDetailModalOpen, setIsAddressDetailModalOpen] =
    useState(false);

  const openAddItemModal = () => {
    setIsAddItemModalOpen(true);
  };

  const closeAddItemModal = () => {
    setIsAddItemModalOpen(false);
  };

  useEffect(() => {
    fetchNotificationHubData(1);
  }, []);

  // fetch notification data
  const fetchNotificationHubData = async (currentPage, size = pageSize) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_NOTIFICATION_MASTER}?&pageSize=${size}&pageNo=${currentPage}`,
        requestBody
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setLoading(false);
        setPageDetails(response?.data?.pageDetails);
        setAcceptHub(false);
        const modifiedData = modifyStructure(response?.data?.data);
        setData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setLoading(false);
        setNoData(true);
        setData([]);
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((user, index) => {
      let formattedCreDate = null;
      let formattedStrDate = null;

      if (user?.createdDate) {
        const parsed = parse(
          user.createdDate,
          "dd-MM-yyyy HH:mm:ss",
          new Date()
        );
        if (isValid(parsed)) {
          formattedCreDate = parsed;
        } else {
          console.warn("Invalid createdDate:", user.createdDate);
        }
      }

      if (user?.startDateTime) {
        const parsed = parse(
          user.startDateTime,
          "dd-MM-yyyy HH:mm:ss",
          new Date()
        );
        if (isValid(parsed)) {
          formattedStrDate = parsed;
        } else {
          console.warn("Invalid startDateTime:", user.startDateTime);
        }
      }

      const itemCount = user.itemsIncluded?.length || 0;

      const itemsIncludedIds = Array.isArray(user.itemsIncluded)
        ? user.itemsIncluded
        : []; // backend expects array

      return {
        ...user,

        itemsIncludedIds,

        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",

        startDateTime: formattedStrDate
          ? [
              format(formattedStrDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedStrDate, "HH:mm:ss"),
            ]
          : "",

        itemsIncluded: (
          <span
            className="text-blue-600 underline cursor-pointer"
            onClick={() => handleItemsIncludedClick(user)}
          >
            {itemCount > 0
              ? `${itemCount} Item${itemCount > 1 ? "s" : ""}`
              : "No Items"}
          </span>
        ),

        customerCode: `${user?.customerDetails?.customerCode || "N/A"} -   ${user?.customerDetails?.name || "N/A"}`,

        address: `${user?.customerDetails?.address1 || ""}${user?.customerDetails?.address2 || ""}${user?.customerDetails?.address3 || ""}`,

        deliveryBoy: user?.deliverBoy?.fullName || "N/A",
      };
    });
  };

  const handleItemsIncludedClick = (row) => {
    setEditData(row);
    setColumnData(row);
    setIsAddItemModalOpen(true);
    fetchOrderData(1, "ItemsIncluded", row);
    setAutoSelectAll(true);
  };

  // fetch order data for add items modal
  const fetchOrderData = async (currentPage, flag, row) => {
    setLoadingModal(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        ...(flag === "addItem"
          ? { excludeBaggedOrders: true }
          : { itemsIncluded: row?.itemsIncluded || [] }),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_ORDER_MASTER_DATA}?pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetailsModal(response?.data?.pageDetails);
        const modifiedData = modifyStructureForModal(response?.data?.data);
        setOrderData(modifiedData);
      } else if (response?.data?.respCode === "01") {
        setOrderData([]);
      } else {
        setOrderData([]);
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Failed to fetch data",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setOrderData([]);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoadingModal(false);
    }
  };

  const modifyStructureForModal = (response) => {
    const modified = response?.map((user, index) => {
      const formattedCreDate = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;
      return {
        ...user,
        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",
      };
    });
    return modified;
  };

  const customerHeader = [
    "Bag No",
    "LMBP User Id",
    "LMBP Id/Name",
    "Address",
    "Status",
    "Items Included",
    "Expected Time",
    "Pickup Boy",
  ];

  const customerHeaderToKeyMap = {
    "Bag No": "bagNo",
    "LMBP User Id": "createdBy",
    "LMBP Id/Name": "customerCode",
    "Address": "address",
    Status: "status",
    "Items Included": "itemsIncluded",
    "Expected Time": "startDateTime",
    "Pickup Boy": "deliveryBoy",
  };

  const handleAuthorization = (data, actionType = "view") => {
    console.log("::data::", data);
  };

  const handleAction = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);

    if (actionType === "assign") {
      setDeliveryModalOpen(true);
      setEditData(data);
    } else if (actionType === "acceptOtp") {
      setEditData(data);
      setColumnData(data);
      handelDoubleSendOtp(data);
    } else if (actionType === "acceptOtpHub") {
      setEditData(data);
      setColumnData(data);
      handelDoubleSendOtp(data);
      setAcceptHub(true);
    } else if (actionType === "open") {
      setEditData(data);
      setColumnData(data);
      handleOpenBox(data);
    } else if (actionType === "address") {
      setEditData(data);
      setColumnData(data);
      setIsAddressDetailModalOpen(true);
    } else {
      let custData = data.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
      }
    }
  };

  const handelSendOtp = async (selected) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        mobileNo: selected?.mobileNo,
      };

      const response = await axiosPostApi(
        `${apiList.NOTIFICATION_SEND_OTP}`,
        requestBody
      );
      const data = response?.data?.data;
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setOtpData(data);
        setLoading(false);
        setDeliveryModalOpen(false);
        setOtpModalOpen(true);
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeliverySubmit = (selectedBoy) => {
    // handelSendOtp(selectedBoy);
    setSelectedDeliveryBoy(selectedBoy);
    handelAcceptedByHub(selectedBoy);
  };

  const handelVerifyOtp = async (vOtpData) => {
    setLoading(true);

    try {
      const payload = {
        username: loggedInUserName,
        mobileNo: selectedDeliveryBoy?.mobileNo,
        otp: vOtpData?.sender,
      };

      const response = await axiosPostApi(
        `${apiList.NOTIFICATION_VERIFY_OTP}`,
        payload
      );
      const data = response?.data?.data;
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setOtpModalOpen(false);
        handelAcceptedByHub();
      } else {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handelAcceptedByHub = async (selectedBoy) => {
    setHubLoading(true);

    try {
      const payload = {
        username: loggedInUserName,
        bagNo: columnData?.bagNo,
        deliveryBoyId: selectedBoy?.id,
      };

      const response = await axiosPostApi(`${apiList.ACCEPT_BY_HUB}`, payload);
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
        });
        fetchNotificationHubData(currentPage);
        setDeliveryModalOpen(false);
        setHubLoading(false);
      } else {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
        setHubLoading(false);
      }
    } catch (error) {
      setHubLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handelDoubleSendOtp = async (value) => {
    setIsLoading(true);

    try {
      const payload = {
        username: loggedInUserName,
        bagNo: value?.bagNo,
        retailerId: value?.createdBy,
        deliveryBoyMobileNo: value?.deliverBoy?.mobileNo,
      };

      const response = await axiosPostApi(
        `${apiList.GENERATE_DUAL_OTP_HUB}`,
        payload
      );
      const data = response?.data?.data;
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setDoubleOtpData(data);
        setIsLoading(false);
        setDoubleOtpModalOpen(true);
      } else {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setIsLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handelDualVerifyOtp = async (vDOtpData) => {
    setLoading(true);

    try {
      const payload = {
        username: loggedInUserName,
        bagNo: columnData?.bagNo,
        firstUserOtp: vDOtpData?.sender,
        deliveryBoyOtp: vDOtpData?.receiver,
      };

      const response = await axiosPostApi(
        `${apiList.VERIFY_DUAL_OTP_HUB}`,
        payload
      );
      const data = response?.data?.data;
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setOtpModalOpen(false);
        handelAcceptedByBoth();
      } else {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handelAcceptedByBoth = async () => {
    setLoading(true);

    try {
      const payload = {
        username: loggedInUserName,
        bagNo: columnData?.bagNo,
        retailerId: columnData?.createdBy,
        deliveryBoyMobileNo: columnData?.deliverBoy?.mobileNo,
      };

      let api = "";
      if (acceptHub) {
        api = apiList.CONFIRM_HUB_ARRIVAL;
      } else {
        api = apiList.HANDOVER_TO_DELIVERY_BOY;
      }

      const response = await axiosPostApi(api, payload);
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
        });
        fetchNotificationHubData(currentPage);
      } else {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = (data) => {
    handelVerifyOtp(data);
  };

  const handleDualOtpSubmit = (data) => {
    handelDualVerifyOtp(data);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const handelOpenBag = async (data) => {
    try {
      const payload = {
        username: loggedInUserName,
        bagNo: data?.bagNo,
        itemsIncluded: data?.itemsIncludedIds,
      };

      const response = await axiosPostApi(`${apiList.OPEN_BAG}`, payload);
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
        });
        fetchNotificationHubData(currentPage);
      } else {
        CustomAlert({
          title: "Failed to Request",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenBox = (data) => {
    CustomAlert({
      title: "Info",
      text: `Are you sure you want to open Bag ${data?.bagNo}? This will update the bag status to "Opened at Hub"`,
      icon: "info",
      cancelButtonText: "Cancel",
      confirmButtonText: "Okay",
      showCancelButton: true,
      cancelButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        handelOpenBag(data);
      }
    });
  };

  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <>
      <HeaderWithBreadcrumb title="Notification Master" breadcrumb="Master" />
      <div>
        <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
          {loading ? (
            <Loader />
          ) : (
            <>
              <MasterTable
                loading={loading}
                headers={customerHeader}
                data={data}
                handleAction={handleAction}
                filterFields={["bagNo"]}
                entityType="NotificationHub"
                headerToKeyMap={customerHeaderToKeyMap}
                handleAuth={handleAuthorization}
                noData={noData}
                pageDetails={pageDetails}
                currentPage={currentPage}
                pageSize={pageSize}
                totalRecord={totalRecord}
                fetchNextData={(page, filters = filterData, size) =>
                  fetchNotificationHubData(page, filters, size)
                }
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                handleReset={handleReset}
                filterData={filterData}
              />
            </>
          )}
          {deliveryModalOpen && (
            <DeliveryBoyModal
              open={deliveryModalOpen}
              onClose={() => setDeliveryModalOpen(false)}
              onSubmit={handleDeliverySubmit}
              hubLoading={hubLoading}
            />
          )}

          <SingleOtpModal
            show={otpModalOpen}
            handleClose={() => setOtpModalOpen(false)}
            bagData={editData} // want to show selected bag info
            onSubmit={handleOtpSubmit}
            data={otpData}
          />

          <AcceptOtpModal
            show={doubleOtpModalOpen}
            handleClose={() => {
              setDoubleOtpModalOpen(false);
              setAcceptHub(false);
            }}
            bagData={editData}
            onSubmit={handleDualOtpSubmit}
            data={doubleOtpData}
          />

          {isAddItemModalOpen ? (
            <AddItemBagModal
              show={isAddItemModalOpen}
              handleClose={closeAddItemModal}
              editData={editData}
              action={modalAction}
              callApi={fetchOrderData}
              callTableApi={fetchNotificationHubData}
              columnData={columnData}
              headers={orderHeader}
              data={orderData}
              totalRecords={pageDetailsModal?.totalRecords || 0}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              loading={loadingModal}
              autoSelectAll={autoSelectAll}
              isViewMode={true}
            />
          ) : null}

          {isAddressDetailModalOpen && (
            <AddressDetailModal
              show={isAddressDetailModalOpen}
              handleClose={() => setIsAddressDetailModalOpen(false)}
              auditData={editData}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationMasterHub;
